<span
  class="hover-popover__trigger"
  tabindex="0"
  (mouseenter)="onEnter($event)"
  (mouseleave)="onLeave()"
>
  <ng-content />
</span>
